import { UIHeading4, UIText2 } from '@cian/ui-kit';
import { IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './PurchaseTerm.css';

interface IPurchaseTermProps {
  onClick(): void;
  logo?: string | null;
  title: string;
  price: string;
  oldPrice?: string | null;
}

export const PurchaseTerm: React.FC<IPurchaseTermProps> = ({ onClick, logo, title, price, oldPrice }) => {
  return (
    <div className={styles['container']} data-testid="PurchaseTerm" onClick={onClick}>
      <div className={styles['wrapper']}>
        <div className={styles['content']}>
          {logo && <img className={styles['logo']} src={logo} alt={title} />}

          <div className={styles['text']}>
            <UIText2>{title}</UIText2>
            <div className={styles['price']}>
              <UIHeading4>{price}</UIHeading4>
              {oldPrice && <div className={styles['old-price']}>{oldPrice}</div>}
            </div>
          </div>
        </div>
        <div className={styles['arrow']}>
          <IconActionChevronRight16 color="icon-secondary-default" />
        </div>
      </div>
    </div>
  );
};
